import React, { useState, useEffect } from "react";
// import { Link, searchParams } from "react-router-dom";
import axios from "axios";
import Container from "@mui/system/Container";
import Box from "@mui/system/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import Dashboard from "../components/intakeManager/Dashboard";
import BaseFilter from "../components/intakeManager/BaseFilter";
import ReviewType from "../components/intakeManager/ReviewType";
import BusinessValidation from "../components/intakeManager/BusinessValidation";
import CasesPage from "../components/intakeManager/Cases";
import ManagerList from "../components/intakeManager/ManagerList";
import requests from "../utility/Requests";
import "./styles/Manager.css";

function ManagerHome() {
  const [dashboardResponse, setDashboardResponse] = useState([]);
  const [dateRange, setDateRange] = useState("");
  const [filterType, setFilterType] = useState("");
  const [pending, setPending] = useState(false);

  const [dropDownValueFromBaseFilter,setDropDownValueFromBaseFilter]=useState('');

  const responseObject =
    dashboardResponse && dashboardResponse.length > 0 && dashboardResponse;

  useEffect(() => {
    if (dateRange || filterType) {
      dashboardData(dateRange, filterType);
    }
  }, [dateRange, filterType]);

  function dashboardData(date, type) {
    setPending(true)
    axios
      .post(requests.dashboard_stats, {
        start_date: date.from,
        end_date: date.to,
        radio: type
      })
      .then(res => {
        setDashboardResponse(res.data.body);
        setPending(false)
      });
  }

  console.log("value in dropDownValueFromBaseFilter:",dropDownValueFromBaseFilter);

//   const commonDashboardComponent=``
// if(dropDownValueFromBaseFilter==='This Month')
// {
  
//           {/* <BaseFilter onStateChangeOfList={(newState)=>{setDropDownValueFromBaseFilter(newState)}} setDateRange={setDateRange} setFilterType={setFilterType} /> */}
           
//     return (
//       <>
//     <div><Backdrop
//   sx={{ color: "#fff", zIndex: theme => theme.zIndex.drawer + 1 }}
//   open={pending}
// >
//   <CircularProgress color="inherit" />
// </Backdrop>

// <Box sx={{ position: "relative", textAlign: "center" }}>
//   <img src="img/heading-bg.png" height="85" style={{ width: "100%" }} />
//   <Typography
//     style={{
//       color: "#fff",
//       fontSize: 30,
//       position: "absolute",
//       top: "50%",
//       left: "50%",
//       transform: " translate(-50%, -50%)"
//     }}
//   >
//     {/* Dashboard Management */}
//     Intake Dashboard
//   </Typography>
// </Box>
// <BaseFilter onStateChangeOfList={(newState)=>{setDropDownValueFromBaseFilter(newState)}} setDateRange={setDateRange} setFilterType={setFilterType} /></div>
//     <iframe
//         title="Authorization Lifecycle Insight"
//         width="1140"
//         height="541.25"
//         src="https://app.powerbi.com/reportEmbed?reportId=6b1f0c5f-380e-4700-b0ef-703cc4cd178e&autoAuth=true&ctid=dafe49bc-5ac3-4310-97b4-3e44a28cbf18"
//         frameBorder="0"
//         allowFullScreen={true}
//       ></iframe>
//       </>
//       )
  



    
  
// }


  return (


    <>
    
    <iframe
        title="Authorization Lifecycle Insight"
        width="100%"
        height="800"
        src="https://app.powerbi.com/reportEmbed?reportId=6b1f0c5f-380e-4700-b0ef-703cc4cd178e&autoAuth=true&ctid=dafe49bc-5ac3-4310-97b4-3e44a28cbf18"
        frameBorder="0"
        allowFullScreen={true}
      ></iframe>
    
    </>
    // <>
    //    <Backdrop
    //     sx={{ color: "#fff", zIndex: theme => theme.zIndex.drawer + 1 }}
    //     open={pending}
    //   >
    //     <CircularProgress color="inherit" />
    //   </Backdrop>
      
    //   <Box sx={{ position: "relative", textAlign: "center" }}>
    //     <img src="img/heading-bg.png" height="85" style={{ width: "100%" }} />
    //     <Typography
    //       style={{
    //         color: "#fff",
    //         fontSize: 30,
    //         position: "absolute",
    //         top: "50%",
    //         left: "50%",
    //         transform: " translate(-50%, -50%)"
    //       }}
    //     >
    //       {/* Dashboard Management */}
    //       Intake Dashboard
    //     </Typography>
    //   </Box>
    //   <BaseFilter onStateChangeOfList={(newState)=>{setDropDownValueFromBaseFilter(newState)}} setDateRange={setDateRange} setFilterType={setFilterType} /> 
     
    //  {/* {dropDownValueFromBaseFilter==='This Month' && {powerBiRenderingComponent}} */}
     
    //  <div>
    //  <Box className="manager-home-page">
    //     <Container maxWidth="xl">
    //       <Dashboard dashboardProps={responseObject} />
    //     </Container>
    //   </Box>

    //   <Box className="white-bg">
    //     <Container maxWidth="xl">
    //       <Grid container columnSpacing={3}>
    //         <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
    //           <ReviewType dashboardProps={responseObject} />
    //         </Grid>
    //         <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
    //           <BusinessValidation dashboardProps={responseObject} />
    //         </Grid>
    //         <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
    //           <CasesPage dashboardProps={responseObject} />
    //         </Grid>
    //         <Grid item xl={9} lg={9} md={9} sm={12} xs={12}>
    //           <ManagerList dashboardProps={responseObject} />
    //         </Grid>
    //       </Grid>
    //     </Container>
    //   </Box>
    //   </div>
    // </>
  )
}

export default ManagerHome;
